import React, { useEffect, useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { AlertCircle } from 'lucide-react';
interface VoidConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (authorizedBy: string, reason: string) => void;
  title?: string;
  description?: string;
  actionLabel?: string;
  isSubmitting?: boolean;
}
export function VoidConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Autorización Requerida',
  description = 'Esta acción requiere autorización. Por favor ingrese su nombre y el motivo de la anulación.',
  actionLabel = 'Confirmar Anulación',
  isSubmitting = false
}: VoidConfirmModalProps) {
  const [authorizedBy, setAuthorizedBy] = useState('');
  const [reason, setReason] = useState('');
  const handleConfirm = () => {
    if (authorizedBy.trim() && reason.trim()) {
      onConfirm(authorizedBy.trim(), reason.trim());
    }
  };
  // Reset state when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setAuthorizedBy('');
      setReason('');
    }
  }, [isOpen]);
  const isValid = authorizedBy.trim().length > 0 && reason.trim().length > 0;
  return <Modal isOpen={isOpen} onClose={onClose} title={title} overlayClassName="z-[200]" data-id="element-1832" data-mp="37t9c76dp5hl5">
      <div className="space-y-4" data-id="element-1833" data-mp="332j61qxg5ape">
        <div className="bg-red-50 text-red-800 p-3 rounded-md flex items-start gap-3" data-id="element-1834" data-mp="33185s137ml31">
          <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-1835" data-mp="3gswbnmmv8dbk" />
          <p className="text-sm" data-id="element-1836" data-mp="3ctdsowelucbd">{description}</p>
        </div>

        <div className="space-y-3" data-id="element-1837" data-mp="3qsdhq5614t82">
          <div data-id="element-1838" data-mp="3qsn6xqj92wcp">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1839" data-mp="3qr2hgfbsm3lp">
              Nombre de quien autoriza <span className="text-red-500" data-id="element-1840" data-mp="3lttv02jm3den">*</span>
            </label>
            <Input value={authorizedBy} onChange={e => setAuthorizedBy(e.target.value)} placeholder="Ej. Juan Pérez (Gerente)" disabled={isSubmitting} data-id="element-1841" data-mp="1wdkp8f0g0ikc" />
          </div>

          <div data-id="element-1842" data-mp="3rjd9j40j5yo3">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1843" data-mp="3rjvfisczvr97">
              Motivo de la anulación <span className="text-red-500" data-id="element-1844" data-mp="d2f3qq0zw5q">*</span>
            </label>
            <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black resize-none" rows={3} value={reason} onChange={e => setReason(e.target.value)} placeholder="Ej. Cliente se retiró, Error de digitación, etc." disabled={isSubmitting} data-id="element-1845" data-mp="4b9o1ze8zt6d" />
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4" data-id="element-1846" data-mp="o369r8l8klkl">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting} data-id="element-1847" data-mp="s13xs839t1me">
            Cancelar
          </Button>
          <Button variant="primary" className="bg-red-600 hover:bg-red-700 text-white border-transparent" onClick={handleConfirm} disabled={!isValid || isSubmitting} data-id="element-1848" data-mp="x3bgdgilvfxp">
            {isSubmitting ? 'Procesando...' : actionLabel}
          </Button>
        </div>
      </div>
    </Modal>;
}